import { Component, OnInit, OnDestroy, Input, Output, NgZone, EventEmitter, PLATFORM_ID, Inject, SimpleChanges } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
// ngrx store
import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';
import { Subscription } from 'rxjs';
// import 'rxjs/add/operator/catch';
import { catchError } from 'rxjs/operators';
// models
import { CollectionLocation } from '../../../models/collection.interface';
import { GetLocationItem } from '../../../models/get-location.interface';
// service
import { CollectionService } from '../../../services/collection.service';
import { SharedService } from '../../../../shared/services/shared-service.service';
// globals
import { AGM_MAP_STYLE } from '../../../../shared/globals';
// interface
import { AppState } from 'app/booking/models/app-state.interface';

declare var ga: any;
declare var exponea: any;

@Component({
  selector: 'app-hotel-business',
  templateUrl: './hotel-business.component.html',
  styleUrls: ['./hotel-business.component.scss']
})
export class HotelBusinessComponent implements OnInit, OnDestroy {

  @Input()
  bookingType;

  @Input()
  bookingState;

  @Input()
  currentBooking;

  @Input()
  selectedLocationType;

  @Input()
  selectedLocationId;

  @Input()
  selectedLanguage;

  @Input()
  appCopy;

  @Input()
  appAirportCopy;

  @Input()
  isSbbSubsidyApplied;

  @Input()
  isSbbSubsidyAvailable;

  @Input()
  isDbSubsidyAvailable;

  @Input()
  isDbSubsidyApplied;

  @Input()
  isCatDiscountAvailable;

  @Output()
  callGetLocation: EventEmitter<any> = new EventEmitter();

  @Output()
  updatePrice: EventEmitter<any> = new EventEmitter();

  @Output()
  handleShowMenu: EventEmitter<any> = new EventEmitter();

  @Output()
  sendToBooking: EventEmitter<any> = new EventEmitter();

  @Output()
  clearBookingLocation: EventEmitter<any> = new EventEmitter();

  private _locationSubscription: Subscription;
  private _bookingSubscription: Subscription;
  private _geoCoordsValidationSubscription: Subscription;

  public flightDirection;
  public addressLookupPlaceholder;
  public placeSelected = true;
  public isLoading = false;
  public locationData: CollectionLocation = {
    type: null,
    name: '',
    shortName: '',
    geoCoord: null,
    addressLine1: '',
    addressTown: '',
    addressPostCode: '',
    addressCountry: ''
  };
  public selectedAddressLine;
  public errorSubmitEmpty = false;
  public errorNoPostcode = false;
  public errorPostcodeOutsideZone = false;
  public mapStyles = AGM_MAP_STYLE;
  public departureInfo;
  public arrivalInfo;
  public isSbbSubsidyApplicable: boolean = false;
  public isDbSubsidyApplicable: boolean = false;
  public isCatDiscountApplicable: boolean = false;
  public virtualBagsCount;
  public bookingProduct;
  public airlineCode;
  public location;
  public mapImgUrl;

  constructor(
    private _collectionService: CollectionService,
    private _sharedService: SharedService,
    private _ngZone: NgZone,
    private _appStore: Store<AppState>,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit() {
    if (this.selectedLocationType === 2) {
      this.addressLookupPlaceholder = this.appCopy.panelHeader['hotelAddressLookupPlaceholder' + this.selectedLanguage];
    } else if (this.selectedLocationType === 3) {
      this.addressLookupPlaceholder = this.appCopy.panelHeader['businessAddressLookupPlaceholder' + this.selectedLanguage];
    }

    this.setDataSubscriptions();
    if (this.isSbbSubsidyAvailable) { this.isSbbSubsidyApplicable = true; }
    if (this.isDbSubsidyAvailable) { this.isDbSubsidyApplicable = true; }
    if (this.isCatDiscountAvailable) { this.isCatDiscountApplicable = true; }
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (this.selectedLocationType === 2) {
      this.addressLookupPlaceholder = this.appCopy.panelHeader['hotelAddressLookupPlaceholder' + this.selectedLanguage];
    } else if (this.selectedLocationType === 3) {
      this.addressLookupPlaceholder = this.appCopy.panelHeader['businessAddressLookupPlaceholder' + this.selectedLanguage];
    }
  }

  setDataSubscriptions() {

    // used to get data from store
    this.setCurrentStoreVars();

    // subscribe to location data sent from google places
    this._locationSubscription = this._collectionService.locationSubject$
      .subscribe(loc => {

        this._ngZone.run(() => {

          this.isLoading = false;

          if (loc.error) {
            console.log('location error', loc);
            return;
          }

          // if no postcode
          // or no google place selected
          // throw error

          if (loc[0] === 'empty postcode') {
            this.errorNoPostcode = true;
            return;
          }
          if (loc[0] === 'not in zone') {
            this.errorPostcodeOutsideZone = true;
            this.exponeaAddressEvent();

            const currentUrl = location.pathname;
            ga('send', 'event', 'Error', 'Sorry – your postcode is outside our coverage area.', currentUrl);
            return;
          }
          if (loc === 'no place id') {
            this.errorNoPostcode = true;
            this.placeSelected = false;
            return;
          }

          // check postcode is valid
          const geoCoord = loc.location.geoCoord;
          this.location = loc;
          this.loadMapUrl();
          if (this.bookingProduct === 'abc') {
            this._collectionService.validatLocationGeoCoords({ airline: this.airlineCode, airportCode: this.departureInfo.airportCode, geoCoord: geoCoord })
          } else {
            this._collectionService.validatLocationGeoCoords({ airline: this.airlineCode, airportCode: this.arrivalInfo.airportCode, geoCoord: geoCoord })
          }

        });
      });

    this._geoCoordsValidationSubscription = this._collectionService.geoCoordsSubject$
      .subscribe(
        res => {
          this.isSbbSubsidyApplicable = false;
          this.isDbSubsidyApplicable = false;
          this.isCatDiscountApplicable = false;
          this._appStore.dispatch({ type: 'UPDATE_SBB_PUBLIC_TRANSPORT_DISCOUNT_STATUS', payload: res?.response?.isSbbSubsidyApplicable ? true : false });
          this._appStore.dispatch({ type: 'SBB_SUBSIDY_STATUS_UPDATE', payload: res?.response?.isSbbSubsidyApplicable });
          this._appStore.dispatch({ type: 'SBB_SUBSIDY_DB_STATUS_UPDATE', payload: res?.response?.isDbSubsidyApplicable });
          this._appStore.dispatch({ type: 'UPDATE_SBB_PUBLIC_TRANSPORT_DB_DISCOUNT_STATUS', payload: false });
          // this._appStore.dispatch({ type: 'UPDATE_CAT_DISCOUNT_STATUS', payload: res?.response?.isCatDiscountApplicable });
          this._appStore.dispatch({ type: 'CAT_DISCOUNT_AVAILABLE_UPDATE', payload: res?.response?.isCatDiscountApplicable });

          if (res.isValid && res.isCalled) {
            this.isSbbSubsidyApplicable = res.response.isSbbSubsidyApplicable;
            this.isDbSubsidyApplicable = res.response.isDbSubsidyApplicable;
            this.isCatDiscountApplicable = res.response.isCatDiscountApplicable;
            this.locationData = this.location.location;
            this.selectedAddressLine = this.locationData.name;
            this._appStore.dispatch({ type: 'ZONE_INFO_UPDATE', payload: this.location.zoneInfo });
            this.updatePrice.emit({ postCode: this.locationData.addressPostCode, goeCoord: this.locationData.geoCoord });
            this.loadMapUrl();
          } else {
            this.errorPostcodeOutsideZone = true;
            this.exponeaAddressEvent();
            const currentUrl = location.pathname;
            ga('send', 'event', 'Error', 'Sorry – your postcode is outside our coverage area.', currentUrl);
          }
        });


    // if location set in booking
    // and type matches tab
    // set locationData to values
    if (
      this.currentBooking.bookingCompletion.collectionLocationDetails &&
      this.currentBooking.bookingJourney[0].collectionLocation.type === this.selectedLocationType &&
      this.flightDirection === 1
    ) {
      this.locationData = this.currentBooking.bookingJourney[0].collectionLocation;
      this.selectedAddressLine = this.locationData.name;
      this.loadMapUrl();
    } else if (
      this.currentBooking.bookingCompletion.deliveryLocationDetail &&
      this.currentBooking.bookingJourney[0].deliveryLocation.type === this.selectedLocationType &&
      this.flightDirection === 2
    ) {
      this.locationData = this.currentBooking.bookingJourney[0].deliveryLocation;
      this.selectedAddressLine = this.locationData.name;
      this.loadMapUrl();
    }

  }

  loadMapUrl() {
    const state = this.getState(this._appStore);
    const geoCoord = state.bookingReducer.bookingDetails.customerAddress.geoCoord
    let lat, lng;
    if (this.location === undefined) {
      lat = geoCoord.latitude;
      lng = geoCoord.longitude;
    } else {
      lat = this.location.location.geoCoord.latitude;
      lng = this.location.location.geoCoord.longitude;
    }
    this.mapImgUrl = `/api/static-map?lat=${lat}&lng=${lng}&zoom=16&size=370x170`;
  }

  // set booking state to vars
  setCurrentStoreVars() {
    const state = this.getState(this._appStore);
    const flightData = state.flightReducer.flightDetails.flightResponse;
    this.flightDirection = this.bookingState.bookingDetails.journeyLegDetails[0].journeyDirection;
    this.departureInfo = flightData.flightStatusDetails[0].departureAirport;
    this.arrivalInfo = flightData.flightStatusDetails[flightData.flightStatusDetails.length - 1].arrivalAirport;
    this.bookingProduct = state.bookingReducer.bookingDetails.bookingProduct;
    const flightStatusDetails = flightData.flightStatusDetails;
    this.airlineCode = flightStatusDetails[0].airlineCode;
    this._bookingSubscription = this._appStore.select('bookingReducer').subscribe(booking => {
      this.virtualBagsCount = booking.bookingDetails.virtualBagCount;
    });
  }

  changedAddressLine(event) {
    if (event !== '') {
      this.errorSubmitEmpty = false;
    } else {
      this.errorPostcodeOutsideZone = false;
    }
  }

  clearInput(event) {
    this.locationData = {
      type: 4,
      name: '',
      shortName: '',
      geoCoord: null,
      addressLine1: '',
      addressLine2: '',
      addressTown: '',
      addressPostCode: '',
      addressCountry: ''
    };
    this.selectedAddressLine = '';
    this.handleShowMenu.emit(true);
    this.isSbbSubsidyApplicable = false;
    this.isDbSubsidyApplicable = false;
    this.isCatDiscountApplicable = false;
    this._appStore.dispatch({ type: 'SBB_SUBSIDY_DB_STATUS_UPDATE', payload: false });
    this._appStore.dispatch({ type: 'SBB_SUBSIDY_STATUS_UPDATE', payload: false });

    this._appStore.dispatch({ type: 'UPDATE_SBB_PUBLIC_TRANSPORT_DISCOUNT_STATUS', payload: false });
    this._appStore.dispatch({ type: 'UPDATE_SBB_PUBLIC_TRANSPORT_DB_DISCOUNT_STATUS', payload: false });
    this._appStore.dispatch({ type: 'UPDATE_CAT_DISCOUNT_STATUS', payload: false });
    this._appStore.dispatch({ type: 'CAT_DISCOUNT_AVAILABLE_UPDATE', payload: false });
    this.clearBookingLocation.emit();
  }

  toggleShowMenu(event) {
    this.handleShowMenu.emit(event);
  }

  // type ahead address search
  // from google api
  // component location-hotel-business-lookup
  getChildLocation(event) {

    this.resetValidation();
    const state = this.getState(this._appStore);
    const request: GetLocationItem = {
      locationProvider: 1,
      locationType: this.selectedLocationType,
      searchId: event.selectedItem.place_id,
      partialSearch: '',
      airportCode: event.airportCode,
      airline: state.flightReducer.flightDetails.flightResponse.flightStatusDetails[0].airlineCode
    };

    this.callGetLocation.emit(request);
  }

  resetValidation() {
    this.errorNoPostcode = false;
    this.errorSubmitEmpty = false;
    this.errorPostcodeOutsideZone = false;
  }

  handleSubmitLocation(e: Event) {
    e.preventDefault();

    let valid = true;
    this.resetValidation();

    if (this.locationData.addressPostCode === '') {
      valid = false;
      this.errorSubmitEmpty = true;
    }

    if (valid) {
      this.isLoading = true;
      this.errorPostcodeOutsideZone = false;
      this.sendToBooking.emit(this.locationData);
    } else {
      if (isPlatformBrowser(this.platformId)) {
        document.body.scrollTop = 0;
      }
    }
  }

  exponeaAddressEvent() {
    let exponeaEvent;
    let attributes = {};

    if (this.flightDirection === 1) {
      exponeaEvent = 'outside_abccoverage_area';
      attributes = {
        postcode_prefix: this.locationData.addressPostCode,
        origin_airport_code: this.departureInfo.airportCode,
        entry_source: this.getState(this._appStore).d2dReducer.entrySource || 'direct',
      }
    } else {
      exponeaEvent = 'outside_ccdcoverage_area';
      attributes = {
        postcode_prefix: this.locationData.addressPostCode,
        destination_airport_code: this.arrivalInfo.airportCode,
        entry_source: this.getState(this._appStore).d2dReducer.entrySource || 'direct',
      }
    }
    exponea.track(exponeaEvent, attributes);
  }

  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1))
      .subscribe(s => state = s);
    return state;
  }

  ngOnDestroy() {
    this._locationSubscription.unsubscribe();
    this._bookingSubscription.unsubscribe();
    if (this._geoCoordsValidationSubscription) {
      this._geoCoordsValidationSubscription.unsubscribe();
    }
  }

}
